/**
 * The home page is backed by the seeded root category: the only
 * category with `is_system` and no parent. Children reference it via
 * `parent_id`, so it is found by query, never routed to directly.
 */

interface RootCandidate {
  id: number;
  parent_id: number | null;
  is_system: boolean;
}

export const findRootCategory = <T extends RootCandidate>(
  categories: readonly T[] | undefined
): T | undefined =>
  categories?.find(
    (category) => category.is_system && category.parent_id === null
  );
